import React, { lazy, Suspense, useEffect, useRef, useState } from "react";
import MainBanner from "./components/mainBanner";
const HallOfFameTab = lazy(() => import("./components/hallOfFameTab"));
import CategoryMenu from "./components/categoryMenu";
const PastWinners = lazy(() => import("./components/PastWinners"));
const CompetitionsGrid = lazy(() => import("./components/competitionsGrid"));
import { getSubscriptionLobbyContent } from "./subscription-competitions-service";
import { useSubscriptionCompetitionsContext } from "./context";
import Skeleton from "react-loading-skeleton";
import Modal from "../../components/Modal/modal";
import { useAppSelector } from "../../redux/hooks";
import Header from "@/app/(general-header)/header/page";

export const SubscriptionCompetitionsPageContent = () => {
  const isModalOpen = useAppSelector(state => state.modal.isOpen);
  const modalData = useAppSelector(state => state.modal.data);
  const modalOverlay = useAppSelector(state => state.modal.withOverlay);
  const { setLobbyContent, setIsLobbyContentLoading } = useSubscriptionCompetitionsContext();
  const [minimumheight, setMinimumHeight] = useState<string>();
  const ref = useRef<HTMLDivElement>();
  useEffect(() => {
    if (ref.current) {
      setMinimumHeight(`calc(100vh - ${ref.current.getBoundingClientRect().top}px)`);
    }
  }, [ref.current]);

  const [activeTab, setActiveTab] = useState("thisWeek");

  useEffect(() => {
    const abortController = new AbortController();
    getSubscriptionLobbyContent(abortController)
      .then(res => {
        setLobbyContent(res);
        setIsLobbyContentLoading(false);
      })
      .catch(err => console.error(err));
    return () => abortController.abort();
  }, []);

  useEffect(() => {
    const container = document.getElementById("category-section");
    if (!container) return;

    const headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue("--header-height"));

    const menuEl = document.getElementById("category-menu");
    const menuHeight = menuEl?.offsetHeight ?? 0;

    const totalOffset = headerHeight + menuHeight;

    const containerRect = container.getBoundingClientRect();

    if (containerRect.top >= totalOffset) {
      return;
    }

    const top = containerRect.top + window.scrollY - totalOffset;

    window.scrollTo({
      top,
      behavior: "smooth",
    });
  }, [activeTab]);

  return (
    <>
      <header id="botb-header" className="sticky top-0 bg-white z-[1003] botb-pass-header">
        <Header renderModalComponentHere={false} />
      </header>
      <div style={{ minHeight: minimumheight }} ref={ref}>
        <MainBanner />

        <CategoryMenu activeTab={activeTab} onSelect={setActiveTab} />

        <div
          className={"w-full max-w-[1388px] mx-auto px-2.5 lg:px-6 py-6 lg:py-12 min-h-[600px]"}
          id={"category-section"}>
          <Suspense
            name="lobby-page"
            fallback={<Skeleton inline highlightColor="#fff" height={500} containerClassName="w-full bg-[#f1f1f1]" />}>
            {activeTab === "thisWeek" && (
              <div id={"thisWeek"}>
                <CompetitionsGrid />
              </div>
            )}

            {activeTab === "pastWinners" && (
              <div id={"pastWinners"}>
                <PastWinners />
              </div>
            )}

            {activeTab === "hallOfFame" && (
              <div id={"hallOfFame"}>
                <HallOfFameTab />
              </div>
            )}
          </Suspense>
        </div>
        <Modal isOpen={isModalOpen} body={modalData} title="" withOverlay={modalOverlay} />
      </div>
    </>
  );
};
